/**
 * useActiveView.ts
 * Subscribes to Office view changes and updates the store.
 * Automatically shows/hides the presenter overlay.
 */

import { useEffect } from 'react';
import { onViewChange } from '@office/viewService';
import { useAppStore } from '@store/appStore';

export function useActiveView(): void {
  const setViewMode = useAppStore((s) => s.setViewMode);
  const setPresenterOverlayVisible = useAppStore((s) => s.setPresenterOverlayVisible);
  const isOfficeReady = useAppStore((s) => s.isOfficeReady);

  useEffect(() => {
    if (!isOfficeReady) return;

    const unsubscribe = onViewChange((view) => {
      setViewMode(view);
      // Auto-show presenter overlay when entering slideshow mode
      setPresenterOverlayVisible(view === 'read');
    });

    // Cleanup: removes polling listener when component unmounts
    return unsubscribe;
  }, [isOfficeReady, setViewMode, setPresenterOverlayVisible]);
}
